import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from 'app/config.const';
import { IID } from 'app/model/id';
import { ISubject } from 'app/model/soggetto';
import { RESTArray, RESTObject } from '../angular-rest';
import { IPaziente } from './paziente';

// TODO: Refactor this!
@Injectable()
export class Pazienti extends RESTArray<ISubject> {
	constructor($http: HttpClient) {
		super(
			$http,
			`${Config.baseURL}/cerca/pazienti`
		);
	}

	private refreshRef;
	private refCount = 0;

	subscribe() {
		if (this.refCount === 0) {
			this.refreshRef = setInterval(() => { this.refresh() }, Config.pazienti.refreshInterval);
		}
		this.refCount++;

		return super.subscribe(...arguments).add(() => {
			this.refCount--;
			if (this.refCount === 0) {
				clearInterval(this.refreshRef);
			}
		});
	}
}

export class Paziente extends RESTObject<IPaziente> implements IID<string> {
	id: string;

	constructor(httpClient: HttpClient, uri: string, defaultValue?: IPaziente) {
		super(httpClient, uri, defaultValue);
		this.id = defaultValue.id;
	}
}



// WEBPACK FOOTER //
// ./src/app/model/pazienti.ts